import getValidColor from './get-valid-color';

type GetBgColor = {
  backgroundColor: string;
  hexColor: string;
};

export function getBgColor({ backgroundColor, hexColor }: GetBgColor) {
  // since the implementation of the color picker, we can simply return the
  // backgroundColor prop if it's a valid hex color
  if (backgroundColor?.startsWith('#')) {
    return backgroundColor;
  }

  const hasHexcolorDropdown = backgroundColor === 'HEXCOLOR';
  const hasBgHexcolor = hexColor !== '';
  const color =
    hasHexcolorDropdown && hasBgHexcolor
      ? hexColor
      : getValidColor(backgroundColor);
  return color;
}
